/**
 * 6-digit OTP entry, used on /2fa, /step-up, and the /security TOTP/phone
 * verification flows. Wraps the shared <InputOTP> with a 3+separator+3 layout
 * (matches Apple / Google / 1Password) and digit-only filtering.
 */
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "@better-bookkeeping/ui/input-otp";

export function OtpDigits({
  value,
  onChange,
  autoFocus = true,
  disabled = false,
  "data-testid": testId,
}: {
  value: string;
  onChange: (next: string) => void;
  autoFocus?: boolean;
  disabled?: boolean;
  /**
   * Lands on the single real input element that InputOTP keeps behind the six
   * slots (the slots are divs), so a test fills the whole code through this
   * one id.
   *
   * Caller-supplied rather than hard-coded: several screens render two of
   * these at once (/2fa TOTP vs OTP, /step-up, /security), and they are
   * structurally identical in the DOM.
   */
  "data-testid"?: string;
}) {
  return (
    <InputOTP
      maxLength={6}
      value={value}
      onChange={(next) => onChange(next.replace(/\D/g, ""))}
      pattern="^[0-9]*$"
      autoFocus={autoFocus}
      disabled={disabled}
      containerClassName="justify-center"
      data-testid={testId}
    >
      <InputOTPGroup>
        <InputOTPSlot index={0} />
        <InputOTPSlot index={1} />
        <InputOTPSlot index={2} />
      </InputOTPGroup>
      <InputOTPSeparator />
      <InputOTPGroup>
        <InputOTPSlot index={3} />
        <InputOTPSlot index={4} />
        <InputOTPSlot index={5} />
      </InputOTPGroup>
    </InputOTP>
  );
}
